import { MenuLayoutEnum } from '../../__generated__/graphql'
import {
  MenuBlockTypeEnum,
  StarOfTheCraftersBlockModel,
} from '../pages/pub-menu/create/builder/models'
import { StoreCreatePubMenu } from '../pages/pub-menu/create/StoreCreatePubMenu'
import {
  getDescriptionSizeByLayout,
  getImagesColorByTemplate,
  getItemImagePDFWidthByLayout,
  getItemImageSizeByLayout,
  getItemTextPDFWidthByLayout,
  getItemTitleSizeByLayout,
  getLogoSizeByLayout,
  getSpacingsByLayout,
  getTitleSizeByLayout,
} from './blocks/starsOfCrafters'

const COLORS = {
  white: '#ffffff',
  black: '#000000',
  yellow: '#D0942E',
}

export const getStarsOfCraftersStylesConfig = (
  store: StoreCreatePubMenu,
  blockType: StarOfTheCraftersBlockModel['type']
) => {
  const TEMPLATE_BLOCK =
    store.settings.template.body.blocks?.starOfTheCraftersBlock
  const TEMPLATE_NAME = store.settings.template.name
  const SELECTED_LAYOUT = store.settings.templatesForm.layout.value

  const isColoredBlockType =
    blockType === MenuBlockTypeEnum.ColoredStarOfTheCraftersBlock
  const isA4Layout =
    store.settings.templatesForm.layout.value === MenuLayoutEnum.A4

  const titleColorByBlockType = isColoredBlockType
    ? COLORS.yellow
    : TEMPLATE_BLOCK?.color

  const textColorByBlockType = isColoredBlockType
    ? COLORS.white
    : TEMPLATE_BLOCK?.color

  return {
    global: {
      fontFamily: TEMPLATE_BLOCK?.fontFamily,
    },

    sizings: {
      titleSize: getTitleSizeByLayout(SELECTED_LAYOUT),
      logoSize: getLogoSizeByLayout(SELECTED_LAYOUT),
      descriptionSize: getDescriptionSizeByLayout(SELECTED_LAYOUT),
      bodyTitleSize: getItemTitleSizeByLayout(SELECTED_LAYOUT),
      bodyImageSize: !isA4Layout ? 'auto' : '82px',
      brandingLogoSize: !isA4Layout ? '30px' : '45px',
      brandingPdfLogoSize: !isA4Layout ? '25px' : '45px',
      bodyItemImageSize: getItemImageSizeByLayout(SELECTED_LAYOUT),
      bodyItemImageWidth: getItemImagePDFWidthByLayout(SELECTED_LAYOUT),
      bodyItemTextWidth: getItemTextPDFWidthByLayout(SELECTED_LAYOUT),
    },

    spacings: {
      bodyGridSpacings: getSpacingsByLayout(SELECTED_LAYOUT),
      bottomSpacing: !isA4Layout ? 1 : 5,
      bottomPdfSpacing: !isA4Layout ? 0 : 10,
      bodyPaddingTop: !isA4Layout ? 0 : 10,
    },

    colors: {
      textColor: textColorByBlockType,
      imageColor: getImagesColorByTemplate(TEMPLATE_NAME, blockType),
      bodyTitleColor: titleColorByBlockType,
    },
  }
}
